import Warning from './Warning';
import './index.scss';

export { Warning };
